<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="small-modal" @click.self="hide(false)">
        <div class="modal-container">
            <div class="card-header">
                <h4>Ändra granskare för markerade artiklar</h4>
            </div>
            <div class="card-body bg-white">
                <div class="form-group col-md-12 col-lg-6">
                    <label>{{ $t('auditor') }}</label>
                    <select v-model="auditor_id" name="auditor_id" class="form-control">
                        <option value="">Välj granskare</option>
                        <option v-for="user in internal_users" :key="user.id" :value="user.id">{{ user.name }} ({{ user.company.name }})</option>
                    </select>
                </div>
                <p class="text-danger px-3">OBS! Granskare kommer ändras för samtliga markerade artiklar!</p>
            </div>
            <div class="card-footer text-right">
                <button class="btn text-danger" @click="hide(false)" >Avbryt</button>
                <button class="btn btn-success" @click="saveAuditor">Spara</button>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
    props: [
        'printableIds',
        'auditorModal',
        'company'
    ],

    data() {
        return {
            auditor_id: '',
            errors: [],
            visible: false,
        }
    },

    watch: {
        auditorModal (n,o) {
            if (this.auditorModal && !this.visible) this.show()
            else if (!this.auditorModal && this.visible) this.hide(false)
        },
    },
    mounted() {
        this.fetchUsers();
    },
    computed : {
        internal_users(){
            return this.users.filter(user => user.role >= 3);
        },
    },
    

    methods: {
        async fetchUsers(){
            if(this.company){
                var query = "?include_admins=true&company_id=" + this.company;

                const { data } = await axios.get("/api/user" + query);

                let new_data = data.map(user => {
                    user.text = user.name;
                    return user 
                })

                this.users = new_data;
            }
        },

        hide(reload) {
            this.visible = false;
            this.$emit('modal', reload);
        },
        show() {
            this.visible = true;
        },
        async saveAuditor() {
            let params = {
                printable_ids: this.printableIds,
                auditor_id: this.auditor_id,
            }

            const { data } = await axios.post('/api/printable/auditor',params);
            this.hide(true);
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EditAuditorModal.vue